import { MBV2NutritionSummary } from './meal-builder-v2';
import { TagType } from './metadata';

export interface PreConfiguredMeal {
  mealId: string;
  mealName: string;
  mealPrice: number;
  mealDeliveryPrice: number;
  mealType: MealType;
  marketingCopy?: string | null;
  gradient: string;
  sortOrder: number;
  calories: string;
  dietaryTags: string[];
  mealTags: MealTag[];
  primaryImages: Image[];
  secondaryImages: Image[];
  entree: PreConfiguredMealEntree;
  sides: PreConfiguredMealSide[];
  drinks: PreConfiguredMealDrink[];
  nutrition?: MBV2NutritionSummary;
}

export interface MealTag {
  type: TagType;
  value: string;
}

export interface PreConfiguredMealEntree {
  entreeName: string;
  itemId: string;
  itemName: string;
  quantity: number;
  calories: string;
  ingredientsSummary: string;
  unitPrice: number;
  isItemAvailable: boolean;
  contents: PreConfiguredMealEntreeContent[];
}

export interface PreConfiguredMealItem {
  itemId: string;
  itemName: string;
  quantity: number;
  calories?: string | null;
  unitPrice: number;
  isItemAvailable: boolean;
}

export interface PreConfiguredMealEntreeContent extends PreConfiguredMealItem {
  customizationId: number;
  customizationName: string;
}

export interface PreConfiguredMealSide extends PreConfiguredMealItem {
  sideName: string;
}

export interface PreConfiguredMealDrink extends PreConfiguredMealItem {
  drinkName: string;
}

export interface Image {
  imageCategory: string;
  imageUrl: string;
}

export enum MealType {
  Influencer = 'Influencer',
  Lifestyle = 'Lifestyle',
}
